import { render, staticRenderFns } from "./ElectricityMainSection.vue?vue&type=template&id=2e343783"
import script from "./ElectricityMainSection.vue?vue&type=script&lang=js"
export * from "./ElectricityMainSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports